export default __webpack_public_path__ + "static/media/model.a8cc0109.svg";